<div class="layout-footer">
    <div>2025 © NRM Connect.</div>
    <div>Version {{ version }}</div>
    <div><a href="https://solveit.today" target="_blank" style="color: #212529;">Powered by SolveIT.Today</a></div>
</div>
